import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { HorizontalSeparator } from '../separator';
import styles from './text-editor-dropdown.scss';

const TextEditorDropdown = ({ children, itemHeight, theme }) => {
  const containerClassName = classNames(styles.container, 'text-editor-dropdown', get(theme, 'container'));
  const style = get(theme, 'containerStyle');
  const content = React.Children.map(children, child =>
    <div className={styles.item}>
      <div style={{ height: itemHeight }}>
        {child}
      </div>
      <HorizontalSeparator className={styles.separator}/>
    </div>
  );

  return (
    <div className={containerClassName} style={style}>
      {content}
    </div>
  );
};

TextEditorDropdown.propTypes = {
  children: PropTypes.node,
  itemHeight: PropTypes.number,
  theme: PropTypes.object,
};

export default TextEditorDropdown;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-dropdown.js